import { Link, useRouterState } from "@tanstack/react-router";
import { Heart, Map, MessageSquare, Search, User } from "lucide-react";
import { useT, type TranslationKey } from "@/lib/i18n";

const items = [
  { to: "/", labelKey: "nav.map", icon: Map },
  { to: "/search", labelKey: "nav.search", icon: Search },
  { to: "/customer/favourites", labelKey: "nav.favourites", icon: Heart },
  { to: "/customer/enquiries", labelKey: "nav.enquiries", icon: MessageSquare },
  { to: "/customer/profile", labelKey: "nav.profile", icon: User },
] as const satisfies readonly {
  to: string;
  labelKey: TranslationKey;
  icon: React.ComponentType<{ className?: string }>;
}[];

export function BottomNavigation() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const t = useT();
  return (
    <nav
      className="pointer-events-auto fixed inset-x-0 bottom-0 z-30 border-t border-border/60 bg-background/95 backdrop-blur-md md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="mx-auto flex max-w-lg items-stretch justify-between px-2 py-1.5">
        {items.map(({ to, labelKey, icon: Icon }) => {
          const active = to === "/" ? pathname === "/" : pathname.startsWith(to);
          return (
            <li key={to} className="flex-1">
              <Link
                to={to}
                className={`flex flex-col items-center gap-0.5 rounded-xl py-1.5 text-[11px] font-medium transition ${
                  active ? "text-brown-dark" : "text-muted-foreground"
                }`}
              >
                <span
                  className={`flex h-8 w-10 items-center justify-center rounded-lg transition ${
                    active ? "bg-brand text-brown-dark" : ""
                  }`}
                >
                  <Icon className="h-4 w-4" />
                </span>
                {t(labelKey)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
